<template>
<ul >
    <li :class="cantStars>=1?'active':''"><Icon icon="ph:star-fill" /></li>
    <li :class="cantStars>=2?'active':''"><Icon icon="ph:star-fill" /></li>
    <li :class="cantStars>=3?'active':''"><Icon icon="ph:star-fill" /></li>
    <li :class="cantStars>=4?'active':''"><Icon icon="ph:star-fill" /></li>
    <li :class="cantStars>=5?'active':''"><Icon icon="ph:star-fill" /></li>
</ul>
</template>

<script>
export default {
    props:['value'],
    data(){
        return{
            cantStars:this.value
        }
    }
}
</script>
<style>
.ngdialog-content{
    margin:0px;
}
</style>

